export const DEFAULT_ALERT_OPTIONS = {
  autoDismissible: true,
}

export const ALERT_AUTO_DISMISS_DELAY = 5000
export const ALERT_ENTER_ANIMATION_DURATION = 300
export const ALERT_EXIT_ANIMATION_DURATION = 200
